const rawShowMeeting = process.env.REACT_APP_SHOW_MEETING ?? process.env.SHOW_MEETING;

export const features = {
  meetingsEnabled: String(rawShowMeeting || "").toLowerCase() === "true",
};

export function isClientRole(role) {
  return String(role || "client") === "client";
}

export function clientMeetingsAvailableForRole(role) {
  return features.meetingsEnabled;
}

export function currentPortalRole() {
  return localStorage.getItem("portal_role") || (localStorage.getItem("is_superuser") === "true" ? "superuser" : localStorage.getItem("is_partner") === "true" ? "partner" : "client");
}

export function currentUserCanUseMeetings() {
  return features.meetingsEnabled;
}
